module.exports = __webpack_public_path__ + "static/media/point_icon_10.73cb485c.svg";